/**
 * System limits for record operations.
 * These constants define the maximum supported record counts for various operations.
 */

export const MAX_STRING_FILTER_COMBINATIONS = 4

/**
 * Pro account limits
 */
export const PRO_ACCOUNT_MAX_RECORDS = 40000
export const PRO_ACCOUNT_MAX_FIELDS = 10
export const CONTACT_SALES_URL = "https://blindinsight.com/contact"

/**
 * Check if a user has a Pro account
 * @param {Object} user - User object from route loader
 * @returns {boolean} - True if user has Pro account
 */
export function isProAccount(user) {
  if (!user || !user.settings || !user.settings.stripe) {
    return false
  }
  const productName = user.settings.stripe.product_name
  return productName && productName !== "Free"
}
